import React from 'react';
import { Header, Icon } from 'semantic-ui-react';

import { StatusCountsContainer } from './statusCounts.styles';

type StatusCountsProps = {
  dueToday: number;
  failed: number;
  overdue: number;
  triage: number;
  urgent: number;
};

const StatusCounts: React.FC<StatusCountsProps> = ({ dueToday, failed, overdue, triage, urgent }) => {
  return (
    <StatusCountsContainer>
      <Header as="h6">
        <Icon className="status-icon" name="hourglass half" color="green" />
        <span>Due Today: {dueToday}</span>
      </Header>
      <Header as="h6">
        <Icon className="status-icon" name="lightning" color="yellow" />
        <span>Urgent: {urgent}</span>
      </Header>
      <Header as="h6">
        <Icon className="status-icon" name="exclamation" color="red" />
        <span>Overdue: {overdue}</span>
      </Header>
      <Header as="h6">
        <Icon className="status-icon" name="tasks" color="red" />
        <span>Triage: {triage}</span>
      </Header>
      <Header as="h6">
        <Icon className="status-icon" name="close" color="red" />
        <span>Failed: {failed}</span>
      </Header>
    </StatusCountsContainer>
  );
};

export default StatusCounts;
